import { render, staticRenderFns } from "./BaseActionPanelStickyFooter.vue?vue&type=template&id=47f8168a&scoped=true&"
import script from "./BaseActionPanelStickyFooter.vue?vue&type=script&lang=js&"
export * from "./BaseActionPanelStickyFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionPanelStickyFooter.vue?vue&type=style&index=0&id=47f8168a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8168a",
  null
  
)

export default component.exports